import {Injectable} from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {PaymentTermModel} from "../../models/resources/payment-term.model";
import {LanguageService} from "./language.service";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class PaymentTermService extends AResourceService<PaymentTermModel> {
  constructor(private languageService: LanguageService) {
    super('/payment-terms', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{key: 'lang', value: code}];
  }
}
